import React from "react";
import "./styles.css";

function Input({ placeholder, label, value, onChange, style, type, id }) {
  const handleChange = (e) => {
    if (onChange) {
      onChange(e);
    }
  };

  return (
    <div className="inputContainer">
      <label htmlFor={id || "input"}>{label}</label>
      <input
        type={type || "text"}
        id={id || "input"}
        placeholder={placeholder}
        className="input"
        value={value}
        onChange={handleChange}
        style={style}
        autoComplete={type === "email" ? "email" : "off"}
        pattern={
          type === "email"
            ? "[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$" // Patrón para emails válidos
            : type === "tel"
            ? "[0-9]{10,}" // Solo permite números y al menos 10 dígitos
            : undefined
        }
        title={
          type === "email"
            ? "Introduce un correo electrónico válido."
            : type === "tel"
            ? "Introduce un número de celular válido con al menos 10 dígitos."
            : undefined
        }
        required
      />
    </div>
  );
}

export default Input;
